import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class FieldOptionUserModel extends BaseModel {
  static urlPath = "field_options/all_fields/user";

  @attr("json") namePrefix;
  @attr("json") gender;
  @attr("json") maritalStatus;
  @attr("json") commStatus;
}
